"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseFileUploadInput = void 0;
var formik_1 = require("formik");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var react_dropzone_1 = require("react-dropzone");
var image_upload_limits_1 = require("../../../../constants/image-upload-limits");
var ajoneuvoni_nelio_100_jpg_1 = __importDefault(require("../../../../../images/ajoneuvoni-nelio-100.jpg"));
var image_url_1 = require("../../../../utils/image-url");
var convert_file_to_base64_1 = require("./convert-file-to-base64");
var UseFileUploadInput = function (name) {
    var t = (0, react_i18next_1.useTranslation)('FileInput').t;
    var _a = (0, react_1.useState)(ajoneuvoni_nelio_100_jpg_1.default), preview = _a[0], setPreview = _a[1];
    var _b = (0, react_1.useState)(false), isMounted = _b[0], setIsMounted = _b[1];
    var _c = (0, react_1.useState)(null), rejectHint = _c[0], setRejectHint = _c[1];
    var _d = (0, formik_1.useField)({ name: name }), field = _d[0], setValue = _d[2].setValue;
    (0, react_1.useEffect)(function () {
        if (field.value && isMounted === false) {
            var s = (0, image_url_1.imageUrl)(field.value, 48);
            setPreview(s);
            setIsMounted(true);
        }
        else {
            setIsMounted(true);
        }
    }, [setPreview, isMounted, field.value]);
    var onDrop = (0, react_1.useCallback)(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var base64;
        var acceptedFile = _b[0];
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setRejectHint(null);
                    if (!acceptedFile) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, convert_file_to_base64_1.convertFileToBase64)(acceptedFile)];
                case 1:
                    base64 = _c.sent();
                    setPreview(base64);
                    setValue(acceptedFile);
                    _c.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, [setValue, setPreview]);
    var onDropRejected = (0, react_1.useCallback)(function (rejections) {
        var first = rejections[0];
        if (!first)
            return;
        var tooLarge = first.errors.some(function (e) { return e.code === 'file-too-large'; });
        setRejectHint(tooLarge ? t('fileTooLarge') : t('fileRejected'));
    }, [t]);
    var _e = (0, react_dropzone_1.useDropzone)({
        onDrop: onDrop,
        onDropRejected: onDropRejected,
        accept: { 'image/jpeg': ['.jpg', '.jpeg'], 'image/png': ['.png'] },
        maxFiles: 1,
        maxSize: image_upload_limits_1.MAX_IMAGE_FILE_BYTES,
    }), getRootProps = _e.getRootProps, getInputProps = _e.getInputProps;
    return {
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        preview: preview,
        rejectHint: rejectHint,
    };
};
exports.UseFileUploadInput = UseFileUploadInput;
